// extracted by mini-css-extract-plugin
export default {"recommendations":"VisionAI_recommendations__9rDxJ","recommendationItem":"VisionAI_recommendationItem__Wissb"};